<template>
  <div class="row slide-min-height">
    <div class="col-4 col-md-4 offset-md-1 d-flex justify-content-center align-items-center">
      <img class="img-testimonial" :src="testimonial.photo" alt="">
    </div>
    <div class="col-8 col-md-6">
      <div class="card-body d-flex flex-column h-100 justify-content-center">
        <div class="my-4 mx-4 position-relative">
          <i class="start-quote">"</i>
          <i class="end-quote" style="transform: rotate(180deg);">"</i>
          <p class="card-text">{{ testimonial.text }}</p>
        </div>
        <p class="card-text mt-2 legend-author testimonial"><strong>{{ testimonial.author }}</strong></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    testimonial: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.img-testimonial {
  border-radius: 25px;
  height: 250px;
  width: 250px;
}

.start-quote {
  top: 0;
  left: 0;
  font-size: 32px;
  color: #567393;
  font-weight: 500;
  position: absolute;
  transform: translate(-150%, -40%);
}

.end-quote {
  top: 0;
  right: 0;
  font-size: 32px;
  color: #567393;
  font-weight: 500;
  position: absolute;
  transform: rotate(180deg) translate(-130%, 80%) !important;
}

.legend-author {
  font-family: 'GT America Mono';
}

.slide-min-height {
  min-height: 320px;
}

.card-text {
  font-size: 19px;
}

.testimonial{
  padding-bottom: 20px;
}

@media (min-width: 0px) and (max-width: 767px) {
  .img-testimonial {
    height: auto;
    width: 100%;
  }

  .card-text {
    font-size: 18px;
  }

  .start-quote {
    font-size: 2rem;
    transform: translate(-150%, -40%)
  }

  .end-quote {
    font-size: 2rem;
    transform: rotate(180deg) translate(-140%, 80%) !important;
  }


}

@media (min-width: 1900px) {

  .card-text {
    font-size: 21px;
  }

}


</style>
